// src/components/admin/KioskForm.js
import React, { useState } from 'react';

const KioskForm = ({ user = {}, initialData = {}, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    printer_ip: '',
    tenant_id: user?.tenant_id,
    ...initialData
  });

  const isEditMode = !!initialData.id;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData, isEditMode);
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="admin-form-group">
        <label>Kiosk Name</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />
      </div>
      <div className="admin-form-group">
        <label>Printer IP (e.g., 192.168.1.13)</label>
        <input type="text" name="printer_ip" value={formData.printer_ip} onChange={handleChange} />
      </div>

      <div className="admin-form-actions">
        <button type="submit" className="admin-button submit">{isEditMode ? 'Update Kiosk' : 'Add Kiosk'}</button>
        <button type="button" onClick={onCancel} className="admin-button cancel">Cancel</button>
      </div>
    </form>
  );
};

export default KioskForm;